<template>
    <ValidationProvider tag="div" :rules="rules" :name="field.labelSC" :vid="field.id" v-slot="{ errors }">
    <input type="number"
           :name="field.handle"
           :id="field.id"
           :required="field.required"
           :placeholder="field.placeholder"
           v-bind="attributes"
           v-model="currentValue"
           :maxlength="field.maxLength"
           :step="field.number.step"
           :min="field.number.min"
           :max="field.number.max"
    />
        <small class="error">{{ errors[0] }}</small>
    </ValidationProvider>
</template>

<script>
    import Helper from "../Helper";

    export default {
        props: {
            field: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                attributes: {},
                rules: {
                    required: this.field.required,
                },
                currentValue: '',
            }
        },
        mounted() {
            this.attributes = Helper.setupAttributes(this.attributes, this.field.inputAttributes);

            this.currentValue = this.field.value;
        }
    }
</script>